import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderState } from '../../../core/models/loader';
import { LoaderService } from '../../../core/services/loader.service';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgIf, MaterialModule],
  template: '<mat-progress-bar mode="query" *ngIf="show"></mat-progress-bar>',
  styles: [
    `
      .hidden {
        visibility: hidden;
      }
      .loader-overlay {
        position: absolute;
        width: 100%;
        z-index: 500000;
        top: 0;
      }
      .loader {
        height: 4px;
        width: 100%;
        position: relative;
        overflow: hidden;
        background-color: #fff;
      }
      .loader:before {
        display: block;
        position: absolute;
        content: '';
        left: -200px;
        width: 200px;
        height: 4px;
        background-color: red;
        animation: loading 2s linear infinite;
      }
      @keyframes loading {
        from {
          left: -200px;
          width: 30%;
        }
        50% {
          width: 30%;
        }
        70% {
          width: 70%;
        }
        80% {
          left: 50%;
        }
        95% {
          left: 120%;
        }
        to {
          left: 100%;
        }
      }
    `
  ]
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  private loaderService = inject(LoaderService);
  private changeDetector = inject(ChangeDetectorRef);

  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.show = state.show;
      this.changeDetector.detectChanges();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
